import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateEditDialogComponent, TranslateEditDialogData } from '@app/modal/translate-edit-dialog/translate-edit-dialog.component';
import { GridOptions, GridRow, GridRowButton, GridRowButtonDisabledParams } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-email-template',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.css']
})
export class EmailTemplateComponent implements OnInit {
    public emailTemplateKeyno: string;

    public edit?: Edit;

    public selectListWebPages: WebPageItem[] = [];

    public saving = false;

    public deleting = false;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private dialog: MatDialog) {
        this.emailTemplateKeyno = this.stateService.getStateParams()['emailtemplate_keyno'];
    }


    private createGrid() {
        this.grid = new Grid()
            .setRememberId('w_emailtemplate_replaceproc_grid')
            .setLoadDataFunction({
                method: 3845,
                parameters: () => ({ webpage: this.edit?.webpage ?? '' })
            })
            .setKendoConfig({ height: '100%' })
            .setSpecialFunc({
                buttons: this.edit?.setting_can_edit_replaceproc === '1' ? [this.buildEditProductConfigRowButton()] : []
            });
    }

    private buildEditProductConfigRowButton(): GridRowButton {
        return {
            name: 'translate',
            icon: 'far fa-language',
            tooltip: 'translate',
            translateTooltip: true,
            func: (row) => this.openTranslationDialog(row),
            disabled: (row: GridRow, params: GridRowButtonDisabledParams) => { return row['emailtemplate_replaceproc_keyno'] > 0 ? false : true }
        };
    }

    public async openTranslationDialog(emailTemplateReplaceProc: GridRow) {
        if (!!emailTemplateReplaceProc) {
            const edits = await this.datatask.Post(3843, { emailtemplate_replaceproc_keyno: emailTemplateReplaceProc['emailtemplate_replaceproc_keyno'] });
            const dialogRef = this.dialog.open(TranslateEditDialogComponent, {
                width: '120rem',
                maxWidth: '95vw',
                height: '80vh',
                data: <TranslateEditDialogData<EmailTemplateReplaceProcLangEdit>>{
                    heading: `${emailTemplateReplaceProc['replace_word']}: ${emailTemplateReplaceProc['proc_name']}.${emailTemplateReplaceProc['parm_name']}`,
                    textToTranslate: emailTemplateReplaceProc['description'],
                    edits: edits,
                    save: async (data) => {
                        await this.datatask.Post(3844, { edits: data.edits });
                        dialogRef.close();
                        this.grid?.gridfunc?.read();
                    },
                    wordNameKey: 'description',
                    wordIdKey: 'emailtemplate_replaceproc_keyno',
                },
            });
        }
    }

    private async loadEdit() {
        if (!!this.emailTemplateKeyno) {
            this.edit = (await this.datatask.Post(2897, { emailtemplate_keyno: this.emailTemplateKeyno }))[0];
        }
    }

    private async loadWebPages(): Promise<void> {
        this.selectListWebPages = await this.datatask.Post(2899);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2898, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(2900, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadWebPages();
        await this.loadEdit();
        this.createGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    emailtemplate_keyno: number;
    emailtemplate_name: string;
    mail_heading: string;
    mail_body: string;
    mail_to: string;
    mail_copy: string;
    mail_bcc: string;
    mail_from: string;
    reg_datetime: string;
    reg_by_portal_user_keyno: string;
    webpage: string;
    show_setting: string;
    setting_can_edit_replaceproc: string;
}

interface WebPageItem {
    webpage: string;
    webpage_name: string;
}

interface EmailTemplateReplaceProcLangEdit extends Record<string, string> {
    emailtemplate_replaceproc_keyno: string;
    description: string;
    language_id: string;
    language_name: string;
    orderby: string;
    google_language_id: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('emailtemplate', {
//        templateUrl: 'views/components/views/emailtemplate/emailtemplate.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'emailTemplateService', function ($stateParams, stateService, modalService, translateService, emailTemplateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let emailTemplateKeyno = $stateParams.emailtemplate_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                readyEmailBody: true,
//                edit: {},
//                selectListWebPages: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEmailTemplate() {
//                vm.model.edit = (await emailTemplateService.getEmailTemplate({ emailtemplate_keyno: emailTemplateKeyno }))[0];
//            }

//            async function loadWebPages() {
//                vm.model.selectListWebPages = await emailTemplateService.listWebPages();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                emailTemplateService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    emailTemplateService.deleteItem(vm.model.edit).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    }, () => {
//                        vm.model.lockedDelete = false;
//                    });
//                }, () => {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEmailTemplate();
//                loadWebPages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
